// 客源统计
export const queryYesterdayNumber = '/erp/customer/statistics/queryYesterdayNumber';//查询客源统计
export const queryHalfAddCus = '/erp/customer/statistics/queryHalfAddCus';//查询半年新增客源
export const queryHalfYearStatistics = '/erp/customer/statistics/queryHalfYearStatistics';//查询半年成交单数
export const queryCusStatistics = '/erp/customer/statistics/queryCusStatistics';//查询客源销售分析
export const queryStatistics = '/erp/customer/statistics/queryStatistics';//查询业务数据分析
export const queryHouseCustomerStatistic = '/erp/employee/statistic/queryHouseCustomerStatistic';//查询客源统计列表